import React, { useState, useEffect } from 'react';
import CompanyInfo from '../../interface/CompanyInfo';
import { getCompanyInfo } from '../../api/commonApi';

const CompanyInfoPage = () => {
    const [companyInfo, setCompanyInfo] = useState<CompanyInfo | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        fetchCompanyInfo();
    }, []);

    const fetchCompanyInfo = async () => {
        try {
            setLoading(true);
            const response = await getCompanyInfo();
            if (response.data && response.data.data) {
                setCompanyInfo(response.data.data);
                setError(null);
            } else {
                throw new Error('회사 정보를 불러올 수 없습니다.');
            }
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : '회사 정보 조회 중 오류가 발생했습니다.';
            setError(errorMessage);
            console.error('Error fetching company info:', err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="container type_gray"><p>로딩 중...</p></div>;
    }

    if (error) {
        return (
            <div className="container type_gray">
                <section>
                    <div className="inner-box">
                        <div className="round-box">
                            <div className="round-body" style={{textAlign: 'center', padding: '24px 0'}}>
                                <p style={{marginBottom: '16px', color: '#666'}}>서버에 일시적인 문제가 발생했습니다.<br/>잠시 후 다시 시도해주세요.</p>
                                <button
                                    type="button"
                                    className="default-btn"
                                    style={{width: 'auto', padding: '0 24px'}}
                                    onClick={fetchCompanyInfo}
                                >
                                    다시 시도
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    if (!companyInfo) {
        return <div className="container type_gray"><p>회사 정보가 없습니다.</p></div>;
    }

    return (
        <main className="container type_gray">
            <section>
                <div className="inner-box">
                    <div className="round-box">
                        <div className="round-header">
                            <h3 className="round-tit">회사 정보</h3>
                        </div>
                        <div className="round-body">
                            <ul className="detail-info">
                                <li>
                                    <span className="tit">회사</span>
                                    <span className="txt">{companyInfo.companyName || '-'}</span>
                                </li>
                                <li>
                                    <span className="tit">대표자</span>
                                    <span className="txt">{companyInfo.ceo || '-'}</span>
                                </li>
                                <li>
                                    <span className="tit">주소</span>
                                    <span className="txt">
                                    {companyInfo.address1} {companyInfo.address1Detail}
                                  </span>
                                </li>
                                <li>
                                    <span className="tit">사업자등록번호</span>
                                    <span className="txt">{companyInfo.businessNo || '-'}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="no-gap">
                <div className="inner">
                    <div className="round-box">
                        <div className="round-header">
                            <h3 className="round-tit">고객센터</h3>
                        </div>
                        <div className="round-body">
                            <ul className="detail-info">
                                <li>
                                    <span className="tit">전화번호</span>
                                    <span className="txt">{companyInfo.customerService}</span>
                                </li>
                                <li>
                                    <span className="tit">운영시간</span>
                                    <span className="txt">AM 10시 ~ PM 6시</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default CompanyInfoPage;